export * from "./PupilIntro.view";
